import React, { useEffect } from "react";
import { BASE_URL } from "../../../global";
import HelpIcon from "@mui/icons-material/Help";
import moment from "moment";
import { useTheme } from "@emotion/react";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import {
  Button,
  TableContainer,
  Toolbar,
  TextField,
  ButtonGroup,
  Autocomplete,
  Modal,
  Typography,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  useMediaQuery,
  Grid,
  TablePagination,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { getFormattedDates } from "../../../utils/utils";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { showComponent } from "../../helper/helpers";
import { Link, useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Tables from "../../../utils/components/tables";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ExcelUpload from "../../../utils/components/excelUpload";
import { ducMasterListGuide } from "./guide";
import { allSettings } from "../../../utils/components/allSettings";
import ExcelDownload from "../../../utils/components/excelDownload";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import ErrorModal from "../../../utils/components/errorModal";
import ListWrap from "../../commonComponent/listWrap";
import { paginationrowsPerPageOptions } from "../../../constants/commonConst";

var columns = [
  {
    id: "id",
    label: "Sr. No.",
    align: "left",
    minWidth: 40,
  },
  {
    id: "companyName",
    label: "Client Name",
    align: "left",
    minWidth: 40,
  },
  {
    id: "instrumentName",
    label: "Instrument Name",
    align: "left",
    minWidth: 40,
  },
  {
    id: "DUCID",
    label: "DUCID",
    align: "left",
    minWidth: 40,
  },
  {
    id: "serialNumber",
    label: "Serial Number",
    align: "left",
    minWidth: 40,
  },

  {
    id: "make",
    label: "Make",
    align: "left",
    minWidth: 40,
  },
  {
    id: "model",
    label: "Model",
    align: "left",
    minWidth: 40,
  },
  {
    id: "ranges",
    label: "Ranges",
    align: "left",
    minWidth: 40,
  },
  {
    id: "lc",
    label: "LC",
    align: "left",
    minWidth: 40,
  },
  {
    id: "locationOfInstrument",
    label: "Location Of Instrument",
    align: "left",
    minWidth: 40,
  },
  {
    id: "department",
    label: "Department",
    align: "left",
    minWidth: 40,
  },
  {
    id: "accuracy",
    label: "Accuracy",
    align: "left",
    minWidth: 40,
  },
  {
    id: "calFrequency",
    label: "Cal Frequency",
    align: "left",
    minWidth: 40,
  },
  {
      id: "calibrationDate",
      label: "Cal.Date",
      minWidth: 40,
      align: "left",
    },
    {
      id: "DueDate",
      label: "Due Date",
      minWidth: 40,
      align: "left",
    },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

let notNeededColumn = ["id","instrumentId","clientId","lastModified","createdBy","extraColumns"];

const DucMasterList = () => {
  const ducMasterListGuides = ducMasterListGuide();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const urlPath = useLocation();
  const [page, setPage] = React.useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [excelData, setExcelData] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "DUCID");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [totalRows, setTotalRows] = React.useState(0);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [data, setFinalData] = React.useState([]);
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [searched, setSearched] = React.useState(false);
  const [editAccess, setEditAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
   
  const [totalInstruments, setTotalInstruments] = React.useState(0);
  const [totalDueInstruments, setTotalDueInstruments] = React.useState(0);
  

  const openErrorModal = (errorMessage,stackTrace,fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const getQuery = (count = false, removePagination = false) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (searchBy !== "" && searchKey != "") {
      let colName = {
        "	Client Name": "companyName",
        "Instrument Name": "instrumentName",
        "Location Of Instrument": "locationOfInstrument",
        Department: "department",
        DUCID: "DUCID",
        "Serial Number": "serialNumber",
        "Model": "model",
      }[searchBy];
      whereConditions = `where LOWER(${colName}) like LOWER('%${searchKey}%')`;
    }
    if (to != null && from != null) {
      const { fromDate, toDate } = getFormattedDates(from, to);
      if (whereConditions === "") {
        whereConditions = " where ";
      } else {
        whereConditions += " and ";
      }
      whereConditions += ` DueDate between '${fromDate}' and '${toDate}'`;
    }

    if (_userType == 3) {
        whereConditions +=
          whereConditions.length > 0
            ? `and ducMaster.clientId = ${_clientId}`
            : `and ducMaster.clientId = ${_clientId}`;
    }
    // whereConditions +=
    //   whereConditions.length > 0
    //     ? " AND cert.status = 1"
    //     : "AND cert.status = 1";

    if (!removePagination && rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

    let data = {
      query: `SELECT clients.companyName, instruments.instrumentName, ducMaster.*, REPLACE(REPLACE(REPLACE(ducMaster.ranges, '#', ''), '||', ','), '|', ' to ') AS ranges, REPLACE(REPLACE(REPLACE(ducMaster.lc, '#', ''), '||', ','), '|', ' to ') AS lc, REPLACE(REPLACE(REPLACE(ducMaster.accuracy, '#', ''), '||', ','), '|', ' to ') AS accuracy FROM ducMaster JOIN clients ON ducMaster.clientId = clients.id JOIN instruments ON ducMaster.instrumentId = instruments.id ${whereConditions}  order by id DESC ${pagination_settings}`,
    };

    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows FROM ducMaster JOIN clients ON ducMaster.clientId = clients.id JOIN instruments ON ducMaster.instrumentId = instruments.id  ${whereConditions}`;
    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "getTotalRows" ,"Duc MasterList")}><u>Error: {err.message}</u></h6>);
        }
      });
  }

  function fetchFinalData() {
    getTotalRows();
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("srfs data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "fetchFinalData" ,"Duc MasterList")}><u>Error: {err.message}</u></h6>);
        }
      });
  }

  function fetchAllDataForExcel() {
    const data = getQuery(false, true);
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        const formattedData = res.data.map((item) => ({
        ...item,
        calibrationDate: item.calibrationDate ? moment(item.calibrationDate).format("DD-MM-YYYY") : "-",
        DueDate: item.DueDate ? moment(item.DueDate).format("DD-MM-YYYY") : "-",
      }));
        setExcelData(formattedData);
      })
      .catch((err) => console.log("Failed to fetch data for Excel export"));
  }

  // Add this function to fetch the counts:
  function getInstrumentCounts() {
    let whereConditions = "";
    
    if (_userType == 3) {
      whereConditions = `where ducMaster.clientId = ${_clientId}`;
    }
    // Query for total instruments
    const totalQuery = {
      query: `SELECT COUNT(*) AS total FROM ducMaster ${whereConditions}`
    };
    // Query for due instruments (within 10 days)
    const dueWhereConditions = whereConditions 
      ? `${whereConditions} AND DueDate <= DATE_ADD(CURDATE(), INTERVAL 10 DAY)`
      : `where DueDate <= DATE_ADD(CURDATE(), INTERVAL 10 DAY)`;
      
    const dueQuery = {
      query: `SELECT COUNT(*) AS total_due FROM ducMaster ${dueWhereConditions}`
    };
    // Fetch total instruments count
    axiosWithToken
      .post(BASE_URL + `dynamic`, totalQuery)
      .then((res) => {
        setTotalInstruments(res.data[0]?.total || 0);
      })
      .catch((err) => {
        console.log("Error fetching total instruments: ", err);
      });

    // Fetch due instruments count
    axiosWithToken
      .post(BASE_URL + `dynamic`, dueQuery)
      .then((res) => {
        setTotalDueInstruments(res.data[0]?.total_due || 0);
      })
      .catch((err) => {
        console.log("Error fetching due instruments: ", err);
      });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath",urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if(storedSearchBy){
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname); 
    sessionStorage.setItem("ListPageCount", 0);
    setPage(0);
    setSearched(true);
    fetchFinalData();
    fetchAllDataForExcel();
  };
  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched", searched);
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    setPage(0);
    setSearchBy("DUCID");
    setSearchKey("");
    setFrom(null);
    setTo(null);
    setSearched(false); 
  };

  const handleDelete = (id) => {
    const confirmed = window.confirm("Really want to delete DUC?");
    if (!confirmed) {
      return;
    }
    let url = BASE_URL;
    axiosWithToken
      .delete(url + `ducMaster/${id}`)
      .then((res) => {
        toast("ducMaster is deleted!");
        setTimeout(refresh, 500);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "handleDelete" ,"Duc MasterList")}><u>Error: {err.message}</u></h6>);
        }
      });
  };

  const copyDUC = async (id) => {
    const confirmed = window.confirm(
      "Do want to copy and create new DUC using selected DUC?"
    );
    if (!confirmed) {
      return;
    }

    let ducData = await axiosWithToken
      .get(BASE_URL + `ducMaster/${id}`)
      .then((res) => res.data[0] || []);
    delete ducData.id;
    delete ducData.lastModified;

    axiosWithToken.post(BASE_URL + "ducMaster", ducData).then((res) => {
      setTimeout(refresh, 500);
    });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    if (searched==false) {
    fetchFinalData();
    fetchAllDataForExcel();
    getInstrumentCounts();
    }
    if (searched) {
      setPage(sessionStorage.getItem("ListPageCount") || 0);
    }
  }, [rowsPerPage,page, searched]);

  const ExcelModal = () => {
    const [open, setOpen] = React.useState(false);
    const [excelArray, setExcelArray] = React.useState([]);
    const [clients, setClients] = React.useState([]);
    const [instruments, setInstruments] = React.useState([]);
    const [additionalColumns, setAdditionalColumns] = React.useState([]);
    const handleOpen = () => setOpen(true);

    const fetchClientsData = () => {
      let url = BASE_URL;
      axiosWithToken
        .get(url + "clients?_fields=id,companyName&_where=(status,eq,1)")
        .then((res) => {
          setClients(res.data);
        })
        .catch((err) => {
          console.log("clients data error: ", err);
          if (err.message !== "request_aborted") {
            toast.error(<h6 onClick={() => openErrorModal(err.message, "fetchClientsData" ,"Duc MasterList")}><u>Error: {err.message}</u></h6>);
          }
        });
    };

    const fetchInstrumentsData = () => {
      let url = BASE_URL;
      axiosWithToken
        .get(url + "instruments?_fields=id,instrumentName&_where=(status,eq,1)")
        .then((res) => {
          setInstruments(res.data);
        })
        .catch((err) => {
          console.log("instruments data error: ", err);
          if (err.message !== "request_aborted") {
            toast.error(<h6 onClick={() => openErrorModal(err.message, "fetchInstrumentsData" ,"Duc MasterList")}><u>Error: {err.message}</u></h6>);
          }
      });
    };

    const fetchSetting = async () => {
      try {
        const AllSettings = await allSettings();
        let additionalColumns = AllSettings.find(
          (ele) => ele.keyName === "srfInstrumentsAdditionalColumns"
        );
        if (additionalColumns) {
          let splitColums = additionalColumns?.value?.split(",");
          setAdditionalColumns(splitColums);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    excelArray.forEach((item) => {
      const extraColumns = {};

      additionalColumns.forEach((key) => {
        const trimmedKey = key;
        if (item.hasOwnProperty(trimmedKey)) {
          extraColumns[trimmedKey] = item[trimmedKey];
        } else {
          extraColumns[trimmedKey] = "";
        }
      });

      item.extraColumns = JSON.stringify(extraColumns);
    });

    // Arrays to hold rejected objects and remaining objects
    let rejectedData = [];
    let remainingData = [];

    // Check for clientId and instrumentId
    for (const excelObj of excelArray) {
      const foundClient = clients.find(
        (client) => client.id === excelObj.clientId
      );
      const foundInstrument = instruments.find(
        (instrument) => instrument.id === excelObj.instrumentId
      );

      if (!foundClient) {
        const rejectedObj = {
          ...excelObj,
          rejectionStatus: "Client is not found in Client database",
        };
        rejectedData.push(rejectedObj);
      } else if (!foundInstrument) {
        const rejectedObj = {
          ...excelObj,
          rejectionStatus: "Instrument is not found in Instrument database",
        };
        rejectedData.push(rejectedObj);
      } else {
        remainingData.push(excelObj);
      }
    }

    var refresh = () => {
      window.location.reload(false);
    };

    const handleSubmit = () => {
      axiosWithToken
        .post(BASE_URL + "ducMaster/bulk", remainingData)
        .then((res) => {
          setTimeout(refresh, 500);
          toast.success("Excel data uploaded Successfully!");
        })
        .catch((err) => {
          if (err.message !== "request_aborted") {
            toast.error(<h6 onClick={() => openErrorModal(err.message, "handleSubmit" ,"Duc MasterList")}><u>Error: {err.message}</u></h6>);
          }
        });
    };
    const handleClose = () => {
      setExcelArray([]);
      rejectedData = [];
      remainingData = [];
      setOpen(false);
    };

    useEffect(() => {
      fetchSetting();
      fetchClientsData();
      fetchInstrumentsData();
    }, []);

    return (
      <div>
        <Button
          id="ducMaster_list_uploadexcel"
          variant="contained"
          size="small"
          onClick={handleOpen}
        >
          Upload Excel File
        </Button>
        {open && 
        <Modal
          open={open}
          onClose={handleClose}
          // BackdropComponent={(props) => (
          //   <div
          //     {...props}
          //     style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 1300 }}
          //   />
          // )}
          style={{maxHeight:"90vh", overflow: "scroll"}}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              sx={{ textAlign: "center" }}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Upload Excel for DUC Master
            </Typography>

            <Typography
              sx={{ textAlign: "right", fontSize: "15px" }}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              {`Rejected Data:${rejectedData.length}, Accepted Data:${remainingData.length}`}
            </Typography>

            <Box style={{ margin: "auto" }}>
              <ExcelUpload
                setExcelArray={setExcelArray}
                buttonName={"Select Excel File"}
                isDUCMaster={true}
              />
            </Box>

            <Typography
              sx={{ textAlign: "center", margin: "15px 0px" }}
              id="modal-modal-title"
              variant="h6"
              component="h6"
            >
              Rejected Excel Data
            </Typography>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="Rejected Data Table">
                <TableHead>
                  <TableRow>
                    <TableCell>Sr.</TableCell>
                    <TableCell>Client ID</TableCell>
                    <TableCell>Instrument ID</TableCell>
                    <TableCell>DUCID</TableCell>
                    <TableCell>Rejection Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rejectedData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.clientId}</TableCell>
                      <TableCell>{row.instrumentId}</TableCell>
                      <TableCell>{row.DUCID}</TableCell>
                      <TableCell>{row.rejectionStatus}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              style={{
                margin: "20px 0px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                variant="contained"
                component="span"
                onClick={handleClose}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                component="span"
                disabled={!remainingData.length > 0}
                onClick={handleSubmit}
              >
                continue
              </Button>
            </Box>
          </Box>
        </Modal>
  }
      </div>
    );
  };

  const actions = [
    {
      id: "edit",
      tooltip: "Edit DUC ",
      link: true,
      linkTo: (id) => `/master/editDucMaster/${id}`,
      icon: <PreviewIcon />,
    },
    {
      id: "copy",
      tooltip: "Copy DUC ",
      icon: <ContentCopyIcon />,
      handler: (row) => copyDUC(row.id),
    },
    {
      id: "delete",
      tooltip: "Delete DUC ",
      icon: <DeleteIcon  style={{ color:!(editAccess?.includes(2) || editAccess?.includes(0)) ? 'lightgray' : '#dc3545' }} />,
      handler: (row) => handleDelete(row.id),
      isDisabled: !(editAccess?.includes(2) || editAccess?.includes(0)),
    },
  ];

  const filterSection = () => (
    <Grid
      container
      spacing={2}
      // justifyContent="flex-end"
      alignItems="center"
      style={{ padding: "5px 0px", marginBottom: "2px" }}
    >
      <Grid item xs={6} sm={3} md={1} lg={1.5}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            slotProps={{ textField: { size: "small", fullWidth: true } }}
            className="Listinputcss"
            label="From"
            value={from ? new Date(from) : null}
            inputFormat="dd/MM/yyyy"
            format="dd/MM/yyyy"
            onChange={(newValue) => {
              setFrom(newValue);
              setSearched(false);
            }}
            renderInput={(params) => <TextField {...params} size="small" />}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={6} sm={3} md={1} lg={1.5}> 
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            slotProps={{ textField: { size: "small", fullWidth: true } }}
            className="Listinputcss"
            label="To"
            value={to ? new Date(to) : null}
            inputFormat="dd/MM/yyyy"
            format="dd/MM/yyyy"
            onChange={(newValue) => {
              setTo(newValue);
              setSearched(false);
            }}
            renderInput={(params) => <TextField {...params} size="small" />}
            style={{ marginRight: "20px" }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={6} md={2} lg={2} id="ducMaster_list_searchby">
        <Autocomplete
          sx={{
            m: 0,
            minWidth: 180,
          }}
          className="Listinputcss"
          size="small"
          value={searchBy}
          options={
            _userType != 3
              ? [
                  { key: "companyName", label: "	Client Name" },
                  { key: "instrumentName", label: "Instrument Name" },
                  { key: "DUCID", label: "DUCID" },
                  { key: "serialNumber", label: "Serial Number" },
                  { key: "model", label: "Model" },
                  {
                    key: "locationOfInstrument",
                    label: "Location Of Instrument",
                  },
                  { key: "department", label: "Department" },
                ]
              : [{ key: "companyName", label: "	Client Name" }]
          }
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(event, newInputValue) => {
            setSearchBy(newInputValue);
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2} lg={2}>
        <TextField
         className="Listinputcss"
          id="ducMaster_list_searchbytext"
          label={"enter " + searchBy}
          size="small"
          inputProps={{
            autoComplete: 'off',
          }}
          value={searchKey}
          variant="outlined"
          onChange={(e) => {
            setSearchKey(e.target.value)
            setSearched(false);
          }}
          style={{ width: "100%" }}
        />
      </Grid>
      <Grid item xs={6} sm={2} md={1} lg={0.5} textAlign={"left"}>
        <Button
          id="ducMaster_list_searchbtn"
          variant="contained"
          size="small"
          color={searched ? "error" : "primary"}
          onClick={() => {
            searched ? clearSearch() : search();
            handleFilterClose();
          }}
        >
          {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </Grid>
      {!isMobile && (
        <Grid item xs={6} sm={4} md={4} lg={2.5}>
          <ExcelModal />
        </Grid>
      )}
      {!isMobile && (
        <Grid item xs={6} sm={3} md={4} lg={2}>
          <ExcelDownload finalData={excelData} notNeededColumn={notNeededColumn} />
        </Grid>
      )}
    </Grid>
  );
  const filterModal = () => {
    return (
      <Modal open={filterModalOpen} size="md">
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "calc(100% - 30%)",
            backgroundColor: "white",
            // border: "2px solid #000",
            boxShadow: 24,
            padding: "10px",
          }}
        >
          <Button
            variant="contained"
            size="small"
            color="error"
            style={{ float: "right" }}
            onClick={handleFilterClose}
          >
            X
          </Button>
          {filterSection()}
        </Box>
      </Modal>
    );
  };

  return (
    <ListWrap>
      {filterModal()}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Toolbar style={{ padding: "0px" }}>
          {/* {showComponent("add") && ( */}
            <Button
              id="ducMaster_list_createbtn"
              variant="contained"
              size="small"
              component={Link}
              to="/master/editDucMaster"
              // onClick={() => {
              //   setTitle("Master/ add new user");
              // }}
            >
              <b>create duc Master</b>
            </Button>
          {/* )} */}
        </Toolbar>
        <Box sx={{ display: "flex", alignItems:"center", gap: "1rem" }}>
          <Button
            style={{ display: isMobile ? "block" : "none" }}
            onClick={handleFilterOpen}
          >
            <FilterAltIcon />
          </Button>
          <div style={{ fontSize: '13px', textAlign:"left", whiteSpace: "nowrap" }}>
              <span style={{ fontSize: '15px', textAlign:"left" }}>
              <strong>Total Instruments:</strong> {totalInstruments} <br/> 
              <strong> Total Due Instruments:</strong> {totalDueInstruments}
            </span>
          </div>
        </Box>
      </div>
      {!isMobile && filterSection()}

      <Box sx={{ width: "100%", overflow: "hidden", display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
        <Table size="small" sx={{ borderCollapse: "collapse" }}  className="table-responsive" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  <b>{column.label}</b>
                </TableCell>
              ))}

              {actions.length > 0 && (
                <TableCell>
                  <b>Actions</b>
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {data?.length > 0 ? (
              data.map((row, index) => (
                <TableRow hover key={row.id || index}>
                  {columns.map((column) => {
                    let value = row[column.id];

                    // format dates
                    if (
                      [
                        "date",
                        "calibrationDate",
                        "dueDate",
                        "expectedReturnDate",
                        "entryDate",
                        "returnDate",
                        "DueDate",
                      ].includes(column.id)
                    ) {
                      value = value ? moment(value).format("DD-MM-YYYY") : null;
                    }

                    // Serial number
                    if (column.id === "id") {
                      value = page * rowsPerPage + (index + 1);
                    }

                    return (
                      <TableCell key={column.id} align={column.align} 
                      style={{ color: moment(row.DueDate).isBefore(moment().add(10, 'days')) ? 'red' : 'inherit'}}
                      >
                        {column.format && typeof value === "number"
                          ? column.format(value)
                          : value}
                      </TableCell>
                    );
                  })}

                  {/* ACTION BUTTONS */}
                  {actions.length > 0 && (
                    <TableCell>
                      <ButtonGroup size="small">
                        {actions.map((action) =>
                          showComponent(action.id) ? (
                            <Tooltip
                              key={action.id}
                              title={action.tooltip}
                              placement="top-start"
                            >
                              {action.link ? (
                                <Button
                                  component={Link}
                                  to={action.linkTo(row.id)}
                                >
                                  {action.icon}
                                </Button>
                              ) : (
                                <Button onClick={() => action.handler(row)}>
                                  {action.icon}
                                </Button>
                              )}
                            </Tooltip>
                          ) : null
                        )}
                      </ButtonGroup>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columns.length + (actions.length > 0 ? 1 : 0)}
                  align="center"
                >
                  <h6>
                    <b>Data Not Found</b>
                  </h6>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={paginationrowsPerPageOptions}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        colSpan={3}
        SelectProps={{
          inputProps: {
            "aria-label": "rows per page",
          },
          native: true,
        }}
        ActionsComponent={TablePaginationActions}
      />
      </Box>
      {errormodalIsOpen && (<ErrorModal errormodalIsOpen={errormodalIsOpen} closeErrorModal={closeErrorModal} errorMessage={errorMessage}/>)}
    </ListWrap>
  );
};

export default DucMasterList;